interface Props {
  eyebrow: string;
  title: string;
  sub?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, sub, align = "left" }: Props) {
  const center = align === "center";
  return (
    <div className={center ? "mx-auto max-w-2xl text-center" : ""}>
      <span className={`inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-800`}>
        <i className="ri-megaphone-line text-sm"></i>
        {eyebrow}
      </span>
      <h2 className={`mt-4 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl ${center ? "" : ""}`}>
        {title}
      </h2>
      {sub && <p className={`mt-3 max-w-2xl text-base text-foreground-700 ${center ? "mx-auto" : ""}`}>{sub}</p>}
    </div>
  );
}